import { Asterisk } from "lucide-react";

const ITEMS = [
  "Shooting fotografico iniziale incluso",
  "3 contenuti pronti ogni mese",
  "Mirlo IA, il tuo assistente",
  "997€ all'anno",
  "Meno di una cena al mese",
  "Dalla parte delle piccole attività",
];

export const Marquee = () => (
  <div data-testid="editorial-marquee" className="overflow-hidden border-y border-purple-100 bg-purple-50/60 py-4">
    <div className="animate-marquee flex w-max items-center">
      {[0, 1].map((copy) => (
        <div key={copy} aria-hidden={copy === 1} className="flex items-center">
          {ITEMS.map((item) => (
            <span key={`${copy}-${item}`} className="flex items-center">
              <span className="whitespace-nowrap px-6 font-heading text-sm font-bold uppercase tracking-[0.15em] text-purple-800/70">
                {item}
              </span>
              <Asterisk className="h-4 w-4 shrink-0 text-purple-400" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
